export const FOOTER_NAVIGATION_ITEMS = [
    {name: 'Privacy And Policy', path: '/privacy'},
    {name: 'Terms of Service', path: '/terms'}
];
